import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Kickstarter from "@/pages/Kickstarter";
import { initLenis, scrollToId } from "@/lib/scroll";

const ScrollManager = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname === "/" && location.hash) {
            setTimeout(() => scrollToId(location.hash), 150);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);
    return null;
};

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <div className="App">
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/kickstarter" element={<Kickstarter />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
